var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { PagerRangeContainerDisabled, PagerRangeContainer } from '../../Table.styled';
import { getAutomation } from '@citrus/runtime';
import { useLocalization } from '@citrus/user';
import { getPageRangeStart, getPageRangeEnd } from './utils';
import localizationMap from '../../../localization';
var PageRange = function (_a) {
    var automationId = _a.automationId, disabled = _a.disabled, _b = _a.itemCount, itemCount = _b === void 0 ? 0 : _b, page = _a.page, pageCount = _a.pageCount, pageSize = _a.pageSize;
    var lang = useLocalization(localizationMap);
    var Component = disabled ? PagerRangeContainerDisabled : PagerRangeContainer;
    if (pageCount <= 0) {
        return (React.createElement(Component, null,
            React.createElement("span", __assign({}, getAutomation(automationId, 'range')),
                "0 ",
                lang.items)));
    }
    var range = lang.pageRange
        .replace('{x}', getPageRangeStart(itemCount, pageCount, pageSize, page).toString())
        .replace('{y}', getPageRangeEnd(itemCount, pageCount, pageSize, page).toString())
        .replace('{z}', itemCount.toString());
    return (React.createElement(Component, null,
        React.createElement("span", __assign({}, getAutomation(automationId, 'range')), range)));
};
export default PageRange;
